module.exports = __webpack_public_path__ + "static/media/tv-dark-gray.49d625cd.svg";